// ** Third Party Components
import styled, { css } from "styled-components";

export const StyledSvgIconContainer = styled.span`
	${({ customMargin }) =>
		customMargin &&
		css`
			margin: ${customMargin};
		`}

	${({ customPadding }) =>
		customPadding &&
		css`
			padding: ${customPadding};
		`}
		
	svg {
		display: inline-block;
		vertical-align: middle;
		fill: ${({ theme: { colors, isDarkMode } }) =>
			isDarkMode ? colors.whiteAlways : colors.blackAlways};

		${({ customHeight }) =>
			customHeight &&
			css`
				height: ${customHeight};
			`};

		${({ customDisplay }) =>
			customDisplay &&
			css`
				display: ${customDisplay};
			`};

		${({ customVerticalAlign }) =>
			customVerticalAlign &&
			css`
				vertical-align: ${customVerticalAlign};
			`};

		${({ customFill }) =>
			customFill &&
			css`
				fill: ${({ theme: { colors, isDarkMode } }) =>
					isDarkMode ? colors[customFill[0]] : colors[customFill[1]]};
			`};
	}
`;
const DynamicImageIcon = ({
	solid = false,
	customDisplay,
	customVerticalAlign,
	customHeight,
	customMargin,
	customPadding,
	customFill,
}) => {
	return (
		<StyledSvgIconContainer
			customDisplay={customDisplay}
			customVerticalAlign={customVerticalAlign}
			customHeight={customHeight}
			customMargin={customMargin}
			customPadding={customPadding}
			customFill={customFill}
		>
			{solid ? (
				<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512">
					{/*<!--!Font Awesome Free 6.5.2 by @fontawesome - https://fontawesome.com License - https://fontawesome.com/license/free Copyright 2024 Fonticons, Inc.-->*/}
					<path d="M464 448H48c-26.5 0-48-21.5-48-48V112c0-26.5 21.5-48 48-48h416c26.5 0 48 21.5 48 48v288c0 26.5-21.5 48-48 48zM112 120c-30.9 0-56 25.1-56 56s25.1 56 56 56 56-25.1 56-56-25.1-56-56-56zM64 384h384V272l-87.5-87.5c-4.7-4.7-12.3-4.7-17 0L208 320l-55.5-55.5c-4.7-4.7-12.3-4.7-17 0L64 336v48z" />
				</svg>
			) : (
				<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512">
					{/*<!--!Font Awesome Free 6.5.2 by @fontawesome - https://fontawesome.com License - https://fontawesome.com/license/free Copyright 2024 Fonticons, Inc.-->*/}
					<path d="M464 64H48C21.5 64 0 85.5 0 112v288c0 26.5 21.5 48 48 48h416c26.5 0 48-21.5 48-48V112c0-26.5-21.5-48-48-48zm-6 336H54a6 6 0 0 1 -6-6V118a6 6 0 0 1 6-6h404a6 6 0 0 1 6 6v276a6 6 0 0 1 -6 6zM128 152c-22.1 0-40 17.9-40 40s17.9 40 40 40 40-17.9 40-40-17.9-40-40-40zM96 352h320v-80l-87.5-87.5c-4.7-4.7-12.3-4.7-17 0L192 304l-39.5-39.5c-4.7-4.7-12.3-4.7-17 0L96 304v48z" />
				</svg>
			)}
		</StyledSvgIconContainer>
	);
};

export default DynamicImageIcon;
